"use client";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import SvgFeeInfo from "@/app/components/pages-components/cart/promo/promo-icons/SvgFeeInfo";
import useProductPriceInfoPopup from "@/hooks/useProductPriceInfoPopup";

const ProductPriceInfoButton: React.FC<{
  priceInfoData: IProduct["selling_prices"];
}> = ({ priceInfoData }) => {
  const { handleOpenProductPriceInfoPopup } = useProductPriceInfoPopup();
  return (
    <div
      role="button"
      onClick={() => {
        handleOpenProductPriceInfoPopup(priceInfoData);
      }}
    >
      <SvgFeeInfo />
    </div>
  );
};

export default ProductPriceInfoButton;
